import {ProductDataStore} from "../../stores/productDataStore";
import {AppStateService} from "../../services/appStateService";
import {UIService} from "../UIService";

export class InternalBlindSimpleSelectService {
    private productDataStore: ProductDataStore;
    private appStateService: AppStateService;
    private uiService: UIService;

    constructor() {
        this.productDataStore = new ProductDataStore();
        this.appStateService = new AppStateService();
        this.uiService = new UIService();
    }

    public resetInternalBlindControlSide() {
        let initialTopRailId = this.productDataStore.getInitialOptionByName('internalBlindControlSide').id;

        this.productDataStore.updateSelectedOption('internalBlindControlSide', initialTopRailId);
        this.uiService.resetSelectionsByPartName('internalBlindControlSide');
        this.uiService.setSelectedOption(this.uiService.getElementByPartNameAndId('internalBlindControlSide', initialTopRailId));
    }

    public resetInternalBlindBottomRail() {
        let initialTopRailId = this.productDataStore.getInitialOptionByName('internalBlindBottomRail').id;

        this.productDataStore.updateSelectedOption('internalBlindBottomRail', initialTopRailId);
        this.uiService.resetSelectionsByPartName('internalBlindBottomRail');
        this.uiService.setSelectedOption(this.uiService.getElementByPartNameAndId('internalBlindBottomRail', initialTopRailId));
    }
}
